export enum EnvironmentTypes {
  dev = 'dev',
  prod = 'production',
  staging = 'staging',
  testing = 'testing'
}
